<template>
  <div class="report-daily">
    <div class="filter">
      <el-form inline>
        <el-date-picker
          v-model="target_date"
          size="mini"
          :clearable="false"
          type="date">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && isExist" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="column">
      <div class="data time" id="data_time" v-show="dailyData.time">
        <div class="data_body">
          <table class="table table-striped table-bordered">
            <tbody>
              <tr class="header">
                <th>項目</th>
                <td>組数</td>
                <td>客数</td>
                <td>売上<br>（税抜）</td>
              </tr>
              <template v-for="time in dailyData.time">
                <tr :key="time.slug">
                  <th>{{ time.timeName }}</th>
                  <td>{{ time.party|addFigure }}</td>
                  <td>{{ time.person|addFigure }}</td>
                  <td>{{ time.salesExcludeTax|addFigure }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
        <div class="data_footer">
          <table>
            <tbody>
              <tr id="total_time">
                <th>合計</th>
                <td>{{ totalTime.party|addFigure }}</td>
                <td>{{ totalTime.person|addFigure }}</td>
                <td>{{ totalTime.salesExcludeTax|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_footer-->
      </div>
      <!--/data-->
      <div class="data" id="data_total">
        <div class="data_body">
          <table class="table table-striped table-bordered">
            <tbody>
              <tr class="header">
                <th>項目</th>
                <td>金額</td>
              </tr>
              <tr id="settled_account_amount">
                <th>精算済売上</th>
                <td>{{ dailyData.payment.settledSales|addFigure }}</td>
              </tr>
              <tr id="outstanding_account_amount">
                <th>未精算売上</th>
                <td>{{ dailyData.daily.outstandingAccountAmount|addFigure }}</td>
              </tr>
              <tr id="refund_account_amount">
                <th>払戻し</th>
                <td>{{ dailyData.payment.totalRefund|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
        <div class="data_footer">
          <table>
            <tbody>
              <tr id="account_grand_amount">
                <th>合計</th>
                <td>{{ dailyData.payment.sales|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_footer-->
      </div>
      <!--/data-->
      <div class="data" id="data_void">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="items">
                <th>販売商品数</th>
                <td>{{ dailyData.daily.totalItem|addFigure }}</td>
              </tr>
              <tr id="sale_items_amount">
                <th>総売上</th>
                <td>{{ dailyData.totalSales|addFigure }}</td>
              </tr>
              <tr id="average_item_unitprice">
                <th>平均商品単価</th>
                <td>{{ rounding(dailyData.itemAverage)|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_void">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="refund_amount">
                <th>払戻し</th>
                <td>{{ dailyData.payment.totalRefund|addFigure }}</td>
              </tr>
              <tr id="refund_count">
                <th>払戻し回数</th>
                <td>{{ dailyData.payment.refundCount|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_sales">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="net_sales_amount">
                <th>売上合計</th>
                <td>{{ dailyData.payment.sales|addFigure }}</td>
              </tr>
              <tr id="gross_sales_ex_tax_amount">
                <th>売上(税抜)</th>
                <td>{{ dailyData.payment.salesExcludeTax|addFigure }}</td>
              </tr>
              <tr v-for="taxData in taxableAmounts" :key="'taxable_amount' + taxData.taxId">
                <th>&nbsp;&nbsp;{{ taxData.taxName }}</th>
                <td>{{ taxData.taxableAmount|addFigure }}</td>
              </tr>
              <tr id="tax_amount_1">
                <th>(消費税)</th>
                <td>{{ dailyData.payment.tax|addFigure }}</td>
              </tr>
              <tr v-for="taxData in dailyData.dailyTax" :key="'tax' + taxData.taxId">
                <th>&nbsp;&nbsp;{{ taxData.taxName }}</th>
                <td>{{ taxData.tax|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_man">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="man_count">
                <th>万券</th>
                <td>{{ dailyData.payment.man|addFigure }}</td>
              </tr>
              <tr id="stamp_tax_count">
                <th>印紙</th>
                <td>{{ dailyData.payment.stampTax|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_cost">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="net_cost_amount">
                <th>売上原価</th>
                <td>{{ dailyData.payment.itemCostPrice|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_close">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="calculated_cash">
                <th>理論レジ金額</th>
                <td>{{ dailyData.daily.cashRemain|addFigure }}</td>
              </tr>
              <tr id="actual_cash">
                <th>レジ金額</th>
                <td>{{ dailyData.daily.cashInRegister|addFigure }}</td>
              </tr>
              <tr id="difference_cash">
                <th>過不足金額</th>
                <td>{{ dailyData.daily.cashOverAndShort|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
    </div>
    <!--/column-->
    <div class="column">
      <div class="data" id="data_payment">
        <div class="data_body">
          <table>
            <tbody>
              <tr class="header">
                <th>項目</th>
                <td>件数</td>
                <td>金額</td>
              </tr>
              <tr v-for="payment in dailyData.payment.payments" :key="payment[0]">
                <th>{{ payment.name }}</th>
                <td>{{ payment.count|addFigure }}</td>
                <td>{{ payment.amount|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_discount">
        <div class="data_body">
          <table>
            <tbody>
              <tr v-for="discount in dailyData.payment.discounts" :key="discount[0]">
                <th>{{ discount.name }}</th>
                <td>{{ discount.count|addFigure }}</td>
                <td>{{ discount.amount|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
        <div class="data_footer">
          <table>
            <tbody>
              <tr id="discount_amount">
                <th>割引・割増合計</th>
                <td>{{ dailyData.payment.totalDiscountCount|addFigure }}</td>
                <td>{{ dailyData.payment.totalDiscount|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_footer-->
      </div>
      <!--/data-->
      <div class="data" id="data_servicecharge">
        <div class="data_body">
          <table>
            <tbody>
              <tr v-for="servicecharge in dailyData.payment.servicecharges" :key="servicecharge[0]">
                <th>{{ servicecharge.name }}</th>
                <td>{{ servicecharge.count|addFigure }}</td>
                <td>{{ servicecharge.amount|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
        <div class="data_footer">
          <table>
            <tbody>
              <tr id="servicecharge_amount">
                <th>サービス料合計</th>
                <td>{{ dailyData.payment.totalServicechargeCount|addFigure }}</td>
                <td>{{ dailyData.payment.totalServicecharge|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_footer-->
      </div>
      <!--/data-->
      <div class="data" id="data_category">
        <div class="data_body">
          <table>
            <tbody>
              <tr v-for="category in dailyData.categories" :key="category.cloud_category_slug">
                <th>{{ setCategoryName(category.categoryName) }}</th>
                <td>{{ category.itemCount|addFigure }}</td>
                <td>{{ category.sales|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_cancel">
        <div class="data_body">
          <table>
            <tbody>
              <tr>
                <th>会計前 取消商品</th>
                <td>{{ dailyData.daily.totalCancelItem|addFigure }}</td>
                <td>{{ dailyData.daily.totalCancelItemAmount|addFigure }}</td>
              </tr>
              <tr>
                <th>注文取消</th>
                <td>{{ dailyData.daily.totalCancelOrder|addFigure }}</td>
                <td>{{ dailyData.daily.totalCancelOrderAmount|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/content_cancel-->
    </div>
    <!--/column-->
    <div class="column">
      <div class="data" id="data_party">
        <div class="data_body">
          <table>
            <tbody>
              <tr class="header">
                <th>項目</th>
                <td>金額</td>
              </tr>
              <tr id="party_amount">
                <th>組数</th>
                <td>{{ dailyData.payment.party|addFigure }}</td>
              </tr>
              <tr id="average_party_sales">
                <th>組単価</th>
                <td>{{ rounding(dailyData.payment.partySales)|addFigure }}</td>
              </tr>
              <tr id="person_count">
                <th>客数</th>
                <td>{{ dailyData.payment.person|addFigure }}</td>
              </tr>
              <tr id="average_person_sales">
                <th>客単価</th>
                <td>{{ rounding(dailyData.payment.personSales)|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_gender">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="male_count">
                <th>男性</th>
                <td>{{ dailyData.payment.male|addFigure }}</td>
              </tr>
              <tr id="female_count">
                <th>女性</th>
                <td>{{ dailyData.payment.female|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
      <div class="data" id="data_attribute">
        <div class="data_body">
          <table>
            <tbody>
              <tr id="teens_count">
                <th>10代</th>
                <td>{{ dailyData.payment.teens|addFigure }}</td>
              </tr>
              <tr id="twenties_count">
                <th>20代</th>
                <td>{{ dailyData.payment.twenties|addFigure }}</td>
              </tr>
              <tr id="thirties_count">
                <th>30代</th>
                <td>{{ dailyData.payment.thirties|addFigure }}</td>
              </tr>
              <tr id="forties_count">
                <th>40代</th>
                <td>{{ dailyData.payment.forties|addFigure }}</td>
              </tr>
              <tr id="fifties_count">
                <th>50代</th>
                <td>{{ dailyData.payment.fifties|addFigure }}</td>
              </tr>
              <tr id="sixties_count">
                <th>60代</th>
                <td>{{ dailyData.payment.sixties|addFigure }}</td>
              </tr>
              <tr id="new_customer_count">
                <th>新規顧客</th>
                <td>{{ dailyData.payment.newCustomer|addFigure }}</td>
              </tr>
              <tr id="attribute_a_count">
                <th>属性A</th>
                <td>{{ dailyData.payment.attributeA|addFigure }}</td>
              </tr>
              <tr id="attribute_b_count">
                <th>属性B</th>
                <td>{{ dailyData.payment.attributeB|addFigure }}</td>
              </tr>
              <tr id="attribute_c_count">
                <th>属性C</th>
                <td>{{ dailyData.payment.attributeC|addFigure }}</td>
              </tr>
              <tr id="attribute_d_count">
                <th>属性D</th>
                <td>{{ dailyData.payment.attributeD|addFigure }}</td>
              </tr>
              <tr id="attribute_e_count">
                <th>属性E</th>
                <td>{{ dailyData.payment.attributeE|addFigure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/data_body-->
      </div>
      <!--/data-->
    </div>
    <!--/column-->
  </div>
</template>

<script>
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'
import {mapGetters} from 'vuex'

export default {
  name: 'ReportDaily',
  data () {
    return {
      rounding: null,
      isLoading: false,
      isExist: false,
      target_date: null,
      dailyData: this.emptyData(),
      csv_filename: '日報.csv',
    }
  },
  computed: {
    ...mapGetters('report', ['roundingFunction']),
    totalTime () {
      let result = {
        party: 0,
        person: 0,
        salesExcludeTax: 0,
      }

      if (!this.dailyData.time) {
        return result
      }

      for (let time of this.dailyData.time) {
        result.party += time.party
        result.person += time.person
        result.salesExcludeTax += time.salesExcludeTax
      }
      return result
    },
    taxableAmounts () {
      // memo: tax_idが正のものだけ取り出す
      if (this.dailyData.dailyTax) {
        return this.dailyData.dailyTax.filter(x => x.taxId > 0)
      }
      return null
    },
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      let tmp = moment(this.target_date).format('YYYY-MM-DD')
      this.$request.reports.dailys(tmp).then(res => {
        if (!res.body) {
          this.dailyData = this.emptyData()
          this.isExist = false
        } else {
          this.dailyData = res.body
          this.isExist = true
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    setCategoryName (name) {
      if (name) {
        return name
      }
      return '未分類'
    },
    emptyData () {
      return {
        daily: {
          totalItem: 0,
          outstandingAccountAmount: 0,
          totalCancelItem: 0,
          totalCancelItemAmount: 0,
          totalCancelOrder: 0,
          totalCancelOrderAmount: 0,
          cashRemain: 0,
          cashInRegister: 0,
          cashOverAndShort: 0,
        },
        dailyTax: null,
        payment: {
          date: null,
          weekdayName: null,
          hour: null,
          sales: 0,
          salesExcludeTax: 0,
          settledSales: 0,
          tax: 0,
          party: 0,
          partySales: 0,
          person: 0,
          personSales: 0,
          male: 0,
          female: 0,
          man: 0,
          stampTax: 0,
          option: 0,
          takeout: 0,
          takeoutCount: 0,
          refundCount: 0,
          totalRefund: 0,
          stay: 0,
          itemCostPrice: 0,
          newCustomer: 0,
          discounts: [],
          totalDiscount: 0,
          totalDiscountCount: 0,
          servicecharges: [],
          totalServicecharge: 0,
          totalServicechargeCount: 0,
          payments: [
            ['', '現金', 0, 0],
          ],
          attributeA: 0,
          attributeB: 0,
          attributeC: 0,
          attributeD: 0,
          attributeE: 0,
          media_1: 0,
          media_2: 0,
          media_3: 0,
          media_4: 0,
          media_5: 0,
          media_6: 0,
          media_99: 0,
          teens: 0,
          twenties: 0,
          thirties: 0,
          forties: 0,
          fifties: 0,
          sixties: 0,
        },
        item: {
          date: null,
          weekdayName: null,
          hour: null,
          itemTotalPrice: 0,
          itemExcludeTaxTotalPrice: 0,
          itemCount: 0,
          optionCount: 0,
          optionTotalPrice: 0,
        },
        categories: null,
        itemAverage: 0,
        totalSales: 0,
      }
    },
    submit () {
    },
    showModal () {
    },
    exportCSV () {
      let header = []
      let data = []
      let tmp = []

      for (let time of this.dailyData.time) {
        header.push(`${time.timeName}-組数`)
        header.push(`${time.timeName}-客数`)
        header.push(`${time.timeName}-売上(税抜)`)
        tmp.push(addFigure(parseInt(time.party)))
        tmp.push(addFigure(parseInt(time.person)))
        tmp.push(addFigure(parseInt(time.salesExcludeTax)))
      }

      header.push(
        '合計-組数',
        '合計-客数',
        '合計-売上(税抜)',
        '精算済売上',
        '未精算売上',
        '払戻し',
        '合計',
        '販売商品数',
        '総売上',
        '平均商品単価',
        '払戻し',
        '払戻し回数',
        '売上合計',
        '売上(税抜)',
      )
      tmp.push(addFigure(parseInt(this.totalTime.party)))
      tmp.push(addFigure(parseInt(this.totalTime.person)))
      tmp.push(addFigure(parseInt(this.totalTime.salesExcludeTax)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.settledSales)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.outstandingAccountAmount)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.totalRefund)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.sales)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.totalItem)))
      tmp.push(addFigure(parseInt(this.dailyData.totalSales)))
      tmp.push(addFigure(parseInt(this.dailyData.itemAverage)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.totalRefund)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.refundCount)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.sales)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.salesExcludeTax)))

      for (let taxData of this.taxableAmounts) {
        header.push(`売上(税抜)-${taxData.taxName}`)
        tmp.push(addFigure(parseInt(taxData.taxableAmount)))
      }

      header.push(
        '(消費税)',
      )
      tmp.push(addFigure(parseInt(this.dailyData.payment.tax)))

      for (let taxData of this.dailyData.dailyTax) {
        header.push(`(消費税)-${taxData.taxName}`)
        tmp.push(addFigure(parseInt(taxData.tax)))
      }

      header.push(
        '万券',
        '印紙',
        '売上原価',
        '理論レジ金額',
        'レジ金額',
        '過不足金額',
      )
      tmp.push(addFigure(parseInt(this.dailyData.payment.man)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.stampTax)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.itemCostPrice)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.cashRemain)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.cashInRegister)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.cashOverAndShort)))

      for (let payment of this.dailyData.payment.payments) {
        header.push(`${payment.name}-件数`)
        header.push(`${payment.name}-金額`)
        tmp.push(addFigure(parseInt(payment.count)))
        tmp.push(addFigure(parseInt(payment.amount)))
      }

      for (let discount of this.dailyData.payment.discounts) {
        header.push(`${discount.name}-件数`)
        header.push(`${discount.name}-金額`)
        tmp.push(addFigure(parseInt(discount.count)))
        tmp.push(addFigure(parseInt(discount.amount)))
      }

      header.push(
        '割引・割増合計-件数',
        '割引・割増合計-金額',
      )
      tmp.push(addFigure(parseInt(this.dailyData.payment.totalDiscountCount)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.totalDiscount)))

      for (let servicecharge of this.dailyData.payment.servicecharges) {
        header.push(`${servicecharge.name}-件数`)
        header.push(`${servicecharge.name}-金額`)
        tmp.push(addFigure(parseInt(servicecharge.count)))
        tmp.push(addFigure(parseInt(servicecharge.amount)))
      }

      header.push(
        'サービス料合計-件数',
        'サービス料合計-金額',
      )
      tmp.push(addFigure(parseInt(this.dailyData.payment.totalServicechargeCount)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.totalServicecharge)))

      for (let category of this.dailyData.categories) {
        header.push(`${this.setCategoryName(category.categoryName)}-件数`)
        header.push(`${this.setCategoryName(category.categoryName)}-金額`)
        tmp.push(addFigure(parseInt(category.itemCount)))
        tmp.push(addFigure(parseInt(category.sales)))
      }

      header.push(
        '会計前 取消商品-件数',
        '会計前 取消商品-金額',
        '注文取消-件数',
        '注文取消-金額',
        '組数',
        '組単価',
        '客数',
        '客単価',
        '男性',
        '女性',
        '10代',
        '20代',
        '30代',
        '40代',
        '50代',
        '60代',
        '新規顧客',
        '属性A',
        '属性B',
        '属性C',
        '属性D',
        '属性E',
      )
      tmp.push(addFigure(parseInt(this.dailyData.daily.totalCancelItem)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.totalCancelItemAmount)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.totalCancelOrder)))
      tmp.push(addFigure(parseInt(this.dailyData.daily.totalCancelOrderAmount)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.party)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.partySales)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.person)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.personSales)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.male)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.female)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.teens)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.twenties)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.thirties)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.forties)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.fifties)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.sixties)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.newCustomer)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.attributeA)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.attributeB)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.attributeC)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.attributeD)))
      tmp.push(addFigure(parseInt(this.dailyData.payment.attributeE)))

      data.push(tmp)

      downloadCSV(this.csv_filename, header, data)
    },
  },
  created () {
    this.rounding = this.roundingFunction
  },
  mounted () {
    this.target_date = moment()
//    this.fetchData()
  },
}
</script>

<style scoped>
.filter {
  width: 100%;
  height: 50px;
  background-color: #FFF;
  border-bottom: 1px solid #EEE;
  overflow: hidden;
  z-index: 10;
}

.filter .el-form--inline {
  height: 50px;
  line-height: 50px;
}

div.column {
  position: relative;
  width: 31.3%;
  margin: 0.5% 1%;
  height: 100%;
  float: left;
}

div.column .data table th {
  width: 50%;
  text-align: left;
  font-weight: normal;
  color: #606266;
}

div.column .data.time table th {
  width: 25%;
  word-break: break-word;
}

div.column .data table td {
  width: 25%;
  text-align: right;
  font-weight: normal;
  color: #606266;
}

.data_footer th, .data_footer td {
  font-weight: bold !important;
  color: #303133 !important;
}

div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}

</style>

<style>
div.report-payment-analyze .el-table td,
div.report-payment-analyze .el-table th {
  padding: 0px;
}
</style>

<style>
@import "./../../../static/styles/report.css";
.report-daily .el-form {
  margin-left: 10px;
}
.report-daily .form-item .el-form-item__content{
  vertical-align: middle !important;
}
.report-daily .header th, .header td {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Daily.vue